export default "__VITE_ASSET__BviZKujn__"